module.exports = __webpack_public_path__ + "static/media/close.84f0b39d.svg";